import React from 'react';
import { Button } from '@mantine/core';
import PropTypes from 'prop-types';
import AppStack from '../../common/AppStack';
import AppText from '../../common/AppText';
import AppFlexbox from '../../common/AppFlexbox';
import AppCheckbox from '../../common/AppCheckbox';

const CreationWizardButton = ({
  label,
  description,
  onClick,
  selected,
  hideCheckbox,
  minHeight,
  children
}) => (
  <Button
    color="dark"
    onClick={onClick}
    radius={8}
    shadow="sm"
    style={{
      padding: 0,
      height: '100%',
      minHeight: minHeight || 50,
      width: '100%',
      flex: 1
    }}
    styles={{ label: { flex: 1 } }}
    type="button"
    variant={selected ? 'filled' : 'light'}
  >
    <AppFlexbox
      style={{
        flex: 1,
        padding: 12,
        gap: 16,
        height: '100%',
        justifyContent: 'space-between'
      }}
    >
      <AppStack
        style={{
          flex: 1,
          gap: 0,
          alignItems: 'start',
          textAlign: 'start',
          textWrap: 'auto',
          whiteSpace: 'normal',
          width: 100
        }}
      >
        <AppText style={{ fontSize: 14, fontWeight: 500 }}>{label}</AppText>
        {description &&
          (typeof description === 'string' ? (
            <AppText
              style={{
                fontSize: 14,
                fontWeight: 'normal',
                color: selected ? '#FFF' : '#666'
              }}
            >
              {description}
            </AppText>
          ) : (
            description
          ))}

        {children}
      </AppStack>

      {!hideCheckbox && (
        <AppStack style={{ justifyContent: 'center' }}>
          <AppCheckbox
            checked={selected ?? false}
            color="dark"
            onChange={() => {}}
          />
        </AppStack>
      )}
    </AppFlexbox>
  </Button>
);

CreationWizardButton.propTypes = {
  children: PropTypes.node,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object
  ]),
  hideCheckbox: PropTypes.bool,
  label: PropTypes.string,
  minHeight: PropTypes.number,
  onClick: PropTypes.func,
  selected: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};

export default CreationWizardButton;
